import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Redirect, Switch } from "react-router-dom";
import 'moment/locale/zh-cn';
import './index.less';
import asyncComponent from './components/async-component';

const placeholder = <span style={{ position: 'fixed', width: '100%', height: '100%', display: 'flex', alignItems: 'center', 'justifyContent': 'center' }}>loading……</span>


const PageLogin = asyncComponent(() => import('./pages/login'), placeholder);
const PageHome = asyncComponent(() => import('./pages/home'), placeholder);
const PageCompany = asyncComponent(() => import('./pages/company'), placeholder); 
const PageFire = asyncComponent(() => import('./pages/fire'), placeholder);

const PageAdmin = asyncComponent(() => import('./pages/admin'), placeholder);
const PageSystemLogs = asyncComponent(() => import('./pages/systemLogs'), placeholder);
const PagePermission = asyncComponent(() => import('./pages/permission'), placeholder);
const PageRole = asyncComponent(() => import('./pages/role'), placeholder);
const PageApk = asyncComponent(() => import('./pages/apk'), placeholder);


const App = () => (
  <Router>
    <Switch>
      <Route exact path="/"><PageCompany /></Route>
      <Route exact path="/check"><PageHome /></Route>
      <Route exact path="/fire"><PageFire /></Route>
      <Route exact path="/login"><PageLogin /></Route>
      <Route exact path="/admin/list"><PageAdmin /></Route>
      <Route exact path="/logs/list"><PageSystemLogs /></Route>
      <Route exact path="/apk/version"><PageApk /></Route>
      <Route exact path="/permission/list"><PagePermission /></Route>
      <Route exact path="/role/list"><PageRole /></Route>
      <Route render={() => (<Redirect to="/result/404" />)} />
    </Switch>
  </Router>
);

ReactDOM.render(<App />, document.getElementById('root'));
